import { http } from '../http-common';

export interface AiCreditPurchaseOptions {
  available: boolean;
  unitPrice: number | null;
}

export interface AiCreditPurchaseRequest {
  creditAmount: number;
  name: string;
  surname: string;
  identityNumber?: string;
  companyName?: string;
  taxNumber?: string;
  taxOffice?: string;
  phone: string;
  email: string;
  city: string;
  billingAddress: string;
}

export interface AiCreditPurchaseInitialization {
  purchaseId: number;
  creditAmount: number;
  unitPrice: number;
  totalAmount: number;
  htmlContent: string;
  redirectUrl?: string;
  transactionId: string;
}

const getOptions = () => http.get<AiCreditPurchaseOptions>('/students/me/ai-credit-purchases/options');

const initializePurchase = (data: AiCreditPurchaseRequest) =>
  http.post<AiCreditPurchaseInitialization>('/students/me/ai-credit-purchases/initialize', data);

const AiCreditPurchaseService = { getOptions, initializePurchase };

export default AiCreditPurchaseService;
